<div class="modal-header">
  <h4 class="modal-title">NCD</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
 <div class="row" *ngIf="!cardClick">
  <div
    class="col-md-4 mb-3"
    *ngFor="let survey of surveyCards; let i = index"
  >
   <div
  class="card text-white mb-3"
  [ngClass]="getCardColor(i)"
  
  (click)="onCardClick(survey)"
  style="cursor: pointer; border-radius: 10px;">
  <div class="card-body text-center">
    <i class="{{ getCardIcon(i) }} fa-2x mb-2"></i>
    <h5 class="card-title">{{ survey }}</h5>
  </div>
</div>

  </div>
</div>

<div *ngIf="cardClick" class="mt-4">

  <!-- Tabs -->
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item" *ngFor="let section of selectedSurvey?.sections; let i = index">
      <a
        class="nav-link"
        [class.active]="i === activeTabIndex"
        (click)="activeTabIndex = i"
        href="javascript:void(0)"
      >
        {{ getSectionLabel(section, i) }}
      </a>
    </li>
  </ul>

  <!-- Questionnaire -->
<div *ngIf="selectedSurvey.sections[activeTabIndex] as activeSection">
  <div class="row">
    <div
      class="col-xl-6 col-lg-6 col-md-12 mb-4"
      *ngFor="let question of activeSection.questions"
    >
      <ng-container [ngSwitch]="question.answerType?.name">

        <!-- Text Box -->
        <div *ngSwitchCase="'Text Box'">
          <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
            {{ getQuestionLabel(question) }}
          </label>
          <input
            type="text"
            class="form-control form-control-sm"
            [(ngModel)]="selectedAnswers[question.id]"
            (change)="updateSurveyDetail(question, $event, 'text')"
          />
        </div>

        <!-- Dropdown -->
        <div *ngSwitchCase="'Dropdown'">
          <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
            {{ getQuestionLabel(question) }}
          </label>
          <select
            class="form-control form-control-sm"
            [(ngModel)]="selectedAnswers[question.id]"
            (change)="updateSurveyDetail(question, $event, 'dropdown')"
          >
            <option value=null>Select</option>
            <option *ngFor="let ans of question.answers" [value]="getAnswerLabel(ans)">
              {{ getAnswerLabel(ans) }}
            </option>
          </select>
        </div>

        <!-- Radio Button -->
        <div *ngSwitchCase="'Radio Button'">
          <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
            {{ getQuestionLabel(question) }}
          </label>
          <div class="d-flex flex-wrap align-items-center">
            <div *ngFor="let ans of question.answers" class="form-check form-check-inline mr-3 mb-0 mt-0">
              <input
                class="form-check-input"
                type="radio"
                [name]="'q_' + question.id"
                [value]="getAnswerLabel(ans)"
                [(ngModel)]="selectedAnswers[question.id]"
                (ngModelChange)="updateSurveyDetail(question, $event, 'radio')"
              />
              <label class="form-check-label">{{ getAnswerLabel(ans) }}</label>
            </div>
          </div>
        </div>

        <!-- Checkbox -->
      

  <div *ngSwitchCase="'Checkbox'">

          <div class="ml-4">
                <input
                class="form-check-input"
                type="checkbox"
                [name]="'q_' + question.id"
                [(ngModel)]="selectedAnswers[question.id]"
                (ngModelChange)="updateSurveyDetail(question, $event, 'checkBox')"/>
          <label class="font-weight-bold d-block mb-2" style="font-size: 15px;"> {{ getQuestionLabel(question) }} </label>
          </div>
        </div>

        <!-- Date Picker -->
        <div *ngSwitchCase="'Current Date'">
          <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
            {{ getQuestionLabel(question) }}
          </label>
          <input
            bsDatepicker
            [bsConfig]="{
              isAnimated: true,
              dateInputFormat: 'DD-MM-YYYY',
              showWeekNumbers: false,
              adaptivePosition: true
            }"
            class="form-control form-control-sm"
            placeholder="DD-MM-YYYY"
            [(ngModel)]="selectedAnswers[question.id]"
            (ngModelChange)="updateSurveyDetail(question, $event, 'date')"
          />
        </div>

        <!-- Fallback -->
        <div *ngSwitchDefault>
          <label class="font-weight-bold d-block mb-2 text-muted" style="font-size: 15px;">
            {{ getQuestionLabel(question) }}
          </label>
          <small class="text-muted">Unsupported input type: {{ question.answerType?.name }}</small>
        </div>

      </ng-container>
    </div>
  </div>

  <!-- Navigation Buttons -->
  <div class="d-flex justify-content-between mt-4">
    <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="activeTabIndex === 0">Back</button>
    <button class="btn btn-primary" (click)="submitSurvey()">Save and Next</button>
  </div>
</div>

</div>




</div>
<div class="modal-footer">
  <button type="button" id="saveButton" class="btn btn-primary btn-sm" *ngIf="cardClick && ncdSaveEnable" (click)="onSubmit()">Save</button>
  <button type="button" id="saveButton" class="btn btn-primary btn-sm" *ngIf="cardClick && !ncdSaveEnable" (click)="onSubmit2()">Save</button>

  <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
    (click)="activeModal.close('Close click')" *ngIf="!cardClick">Close</button>
  <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
    (click)="close()" *ngIf="cardClick">Close</button>
</div>




